/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Filters_Search_PlaceholderInputs */

const es_settings_files_filters_search_placeholder = /** @type {(inputs: Settings_Files_Filters_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar contenido…`)
};

const en_settings_files_filters_search_placeholder = /** @type {(inputs: Settings_Files_Filters_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search content…`)
};

/**
* | output |
* | --- |
* | "Search content…" |
*
* @param {Settings_Files_Filters_Search_PlaceholderInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_filters_search_placeholder = /** @type {((inputs?: Settings_Files_Filters_Search_PlaceholderInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Filters_Search_PlaceholderInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_filters_search_placeholder(inputs)
	return en_settings_files_filters_search_placeholder(inputs)
});
export { settings_files_filters_search_placeholder as "settings.files.filters.search_placeholder" }